import ModalFolderNameForm from "./ModalFolderNameForm";
import { CONTENT_FOLDER_ROOT_ID } from "../../utils/constants";
import {
  BUTTON_CREATE,
  GALLERY_FOLDERS_CREATE_ERROR,
  GALLERY_FOLDERS_CREATE_IN,
  GALLERY_FOLDERS_CREATE_SUCCESS,
  GALLERY_FOLDERS_CREATE_TITLE,
} from "../../i18n/keysTranslations";

const ModalCreateContentFolder = ({
  modalOpen = false,
  folders = [],
  parentFolderID = CONTENT_FOLDER_ROOT_ID,
  parentFolderLabel = null,
  isLoading = false,
  onCloseModal = () => {},
  onCallbackCreate = async () => ({ ok: false }),
}) => {
  return (
    <ModalFolderNameForm
      modalOpen={modalOpen}
      folders={folders}
      parentFolderID={parentFolderID}
      parentFolderLabel={parentFolderLabel}
      parentFolderLabelPrefix={GALLERY_FOLDERS_CREATE_IN}
      initialName=""
      title={GALLERY_FOLDERS_CREATE_TITLE}
      ariaLabel={GALLERY_FOLDERS_CREATE_TITLE}
      primaryButtonText={BUTTON_CREATE}
      errorText={GALLERY_FOLDERS_CREATE_ERROR}
      successText={GALLERY_FOLDERS_CREATE_SUCCESS}
      isLoading={isLoading}
      onCloseModal={onCloseModal}
      onSubmitName={({ name }) =>
        onCallbackCreate({
          name,
          parentFolderID,
        })
      }
    />
  );
};

export default ModalCreateContentFolder;
